import React, { useEffect, useState } from "react";
import styles from "./PDXOModel.module.css";
// 🚨 사용하지 않는 plus, minus 아이콘 임포트를 제거했습니다.
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";
import CancerName from "./CancerName";

// props 대신 { name, search, returnFalse } 구조 분해 할당을 사용하여 코드를 간결하게 만듭니다.
function PDXOModel({ name, search, returnFalse }) {
    const [visibleFirst, setVisibleFirst] = useState(false);
    const [cancerDatas, setData] = useState([]);

    // 페이지네이션 관련 상태
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cancerDatas.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(cancerDatas.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    // 삼항 연산자를 사용하여 checkZero 함수를 한 줄로 깔끔하게 정리했습니다.
    const checkZero = (num) => (num === 0 || !num ? '' : `(${num})`);

    useEffect(() => {
        // 🚨 [보안 핵심] 프론트엔드에서 SQL 쿼리(condition)를 조립하던 코드를 완전히 삭제했습니다!
        // 이제 백엔드가 모든 조건을 처리하도록 순수한 검색어(search)만 보냅니다.
        const reqOption = {
            method: "POST", // HTTP 메서드는 대문자로 표기하는 것이 관례입니다.
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify({
                name: name,
                search: search // 조건문 대신 검색어 원본만 전달
            })
        };

        fetch('/api/getPDXOCancerData', reqOption)
            .then((response) => response.json())
            .then(data => {
                setData(data);
                // ★ 사용자 경험(UX) 개선: 데이터가 새로 들어오면 무조건 1페이지로 돌아가게 해줍니다.
                setCurrentPage(1);
            })
            .catch(err => console.error("PDXO Data fetch error:", err)); // 에러 핸들링 추가

    }, [search, name]);

    return (
        <div className={styles.pdoObject}>
            {/* 개별 span이 아닌 전체 영역(div)에 onClick을 걸어 클릭을 편하게 만들고 코드를 줄입니다. */}
            <div onClick={() => setVisibleFirst(!visibleFirst)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img
                        className={visibleFirst ? styles.minusImg_low : styles.plusImg_low}
                        src={visibleFirst ? downTriangleIcon : sideTriangleIcon}
                        alt={visibleFirst ? "Collapse" : "Expand"}
                    />
                </span>
                <span className={styles.pdoName}>
                    {name}
                    <span className={styles.cancerDataNum}>
                        {checkZero(cancerDatas.length)}
                    </span>
                </span>
            </div>

            {visibleFirst && (
                <div className={styles.contentContainer}>
                    <div className={styles.cancerNamesContainer}>
                        {currentItems.map((data, index) => (
                            // 불필요한 returnFalse 래퍼 함수를 지우고 직접 넘겨줍니다.
                            // 리스트 렌더링을 위해 안전한 고유 key를 부여했습니다.
                            <CancerName
                                data={data}
                                returnFalse={returnFalse}
                                key={`pdxo-cancer-${index}`}
                            />
                        ))}
                    </div>
                    <div className={styles.paginationContainer}>
                        {pageNumbers.map(number => (
                            <span
                                key={number}
                                className={currentPage === number ? styles.activePage : styles.pageNumber}
                                onClick={() => handlePageClick(number)}
                            >
                                {number}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default PDXOModel;